/* Mr Pixel — magnifier lens for the product gallery. */
(function () {
  'use strict';

  var SELECTOR = '.product-media-container.media-type-image';

  function supported() {
    return (
      window.matchMedia('(min-width: 990px)').matches &&
      window.matchMedia('(hover: hover) and (pointer: fine)').matches
    );
  }

  function settings(container) {
    var root = container.closest('product-info') || document.documentElement;
    return {
      zoom: parseFloat(root.dataset.mpLensZoom || '2') || 2,
      shape: root.dataset.mpLensShape === 'square' ? 'square' : 'round',
      size: parseInt(root.dataset.mpLensSize || '220', 10) || 220,
    };
  }

  function highResSrc(img) {
    var src = img.currentSrc || img.src;
    if (!src) return null;
    try {
      var url = new URL(src, window.location.href);
      if (url.searchParams.has('width')) url.searchParams.set('width', '1946');
      return url.href;
    } catch (e) {
      return src;
    }
  }

  function renderedRect(img) {
    var box = img.getBoundingClientRect();
    var natW = img.naturalWidth;
    var natH = img.naturalHeight;
    if (!natW || !natH) return { left: 0, top: 0, width: box.width, height: box.height, box: box };

    var fit = window.getComputedStyle(img).objectFit;

    var scale =
      fit === 'cover'
        ? Math.max(box.width / natW, box.height / natH)
        : Math.min(box.width / natW, box.height / natH);
    var w = natW * scale;
    var h = natH * scale;
    return {
      left: (box.width - w) / 2,
      top: (box.height - h) / 2,
      width: w,
      height: h,
      box: box,
    };
  }

  function Lens(container) {
    this.container = container;
    this.img = container.querySelector('.product__media img');
    if (!this.img) return;

    this.opts = settings(container);
    this.el = document.createElement('div');
    this.el.className = 'mp-lens' + (this.opts.shape === 'square' ? ' mp-lens--square' : '');
    this.el.style.setProperty('--mp-lens-size', this.opts.size + 'px');
    this.el.setAttribute('aria-hidden', 'true');

    this.onEnter = this.show.bind(this);
    this.onMove = this.move.bind(this);
    this.onLeave = this.hide.bind(this);

    container.addEventListener('mouseenter', this.onEnter);
    container.addEventListener('mousemove', this.onMove);
    container.addEventListener('mouseleave', this.onLeave);
    container.mpLens = this;
  }

  Lens.prototype.show = function () {
    if (!supported()) return;
    var src = highResSrc(this.img);
    if (!src) return;

    if (this.el.dataset.src !== src) {
      this.el.style.backgroundImage = 'url("' + src + '")';
      this.el.dataset.src = src;
    }
    if (this.el.parentNode !== this.container) this.container.appendChild(this.el);
    this.container.classList.add('mp-lens-active');
  };

  Lens.prototype.move = function (event) {
    if (!supported() || !this.el.parentNode) return;

    var r = renderedRect(this.img);
    var x = event.clientX - r.box.left;
    var y = event.clientY - r.box.top;

    if (x < r.left || x > r.left + r.width || y < r.top || y > r.top + r.height) {
      this.el.classList.remove('is-visible');
      this.container.classList.remove('mp-lens-active');
      return;
    }

    this.container.classList.add('mp-lens-active');
    this.el.classList.add('is-visible');

    var zoom = this.opts.zoom;
    var size = this.opts.size;
    var bgW = r.width * zoom;
    var bgH = r.height * zoom;
    var relX = (x - r.left) / r.width;
    var relY = (y - r.top) / r.height;

    this.el.style.backgroundSize = bgW + 'px ' + bgH + 'px';
    this.el.style.backgroundPosition =
      -(relX * bgW - size / 2) + 'px ' + -(relY * bgH - size / 2) + 'px';

    this.el.style.left = x - size / 2 + 'px';
    this.el.style.top = y - size / 2 + 'px';
  };

  Lens.prototype.hide = function () {
    this.el.classList.remove('is-visible');
    this.container.classList.remove('mp-lens-active');
  };

  function bindAll(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(function (container) {
      if (container.mpLens) return;
      new Lens(container);
    });
  }

  function init() {
    if (!supported()) return;
    bindAll(document);

    var host = document.querySelector('product-info');
    if (!host || !window.MutationObserver) return;
    new MutationObserver(function () {
      bindAll(document);
    }).observe(host, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
